'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  ::-webkit-outer-spin-button,\n  ::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  [type=number] {\n    -moz-appearance: textfield;\n  }\n'], ['\n  ::-webkit-outer-spin-button,\n  ::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  [type=number] {\n    -moz-appearance: textfield;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _metrixCommon = require('metrix-common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledInput = (0, _styledComponents2.default)(_metrixCommon.Input)(_templateObject);

var WorkflowInput = function (_React$Component) {
    _inherits(WorkflowInput, _React$Component);

    function WorkflowInput(props) {
        _classCallCheck(this, WorkflowInput);

        var _this = _possibleConstructorReturn(this, (WorkflowInput.__proto__ || Object.getPrototypeOf(WorkflowInput)).call(this, props));

        _this.handleReturn = function (value, type) {
            var precision = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

            var allowAlphanumericAndSpaceOnly = (0, _metrixCommon.getElementValueByCode)(_this.props.component.elements, 'AllowAlphanumericAndSpaceOnly');
            var overrideMaxLength = parseInt((0, _metrixCommon.getElementValueByCode)(_this.props.component.elements, 'OverrideMaxLength'));

            var maxLength = void 0;
            var regex = void 0;
            var newValue = value;
            var validate = true;

            if (newValue !== '' && type) {
                switch (type.toLowerCase()) {
                    case 'text':
                        maxLength = overrideMaxLength || 200;
                        regex = allowAlphanumericAndSpaceOnly ? /^[ A-Za-z0-9]*$/ : /^[ A-Za-z0-9_@./#&+\-`'"’~]*$/;
                        if (!regex.test(newValue)) return;

                        break;
                    case 'percent':
                        maxLength = (overrideMaxLength || 9) + 1 + parseInt(precision, 10);

                        // Check if decimal part doesn't exceed precision digits
                        regex = precision > 0 ? new RegExp('^-?\\d*(\\.\\d{0,' + precision + '})?$') : /^-?\\d*$/;
                        if (!regex.test(newValue)) return;

                        // Check if the integer part exceeds maxLength digits
                        var parts = newValue.split('.');
                        if (parts[0].length > overrideMaxLength) return;

                        break;
                    case 'currency':
                        maxLength = overrideMaxLength || 9;
                        newValue = parseFloat(newValue.replace(/[^\d-]/g, ''));

                        if (isNaN(newValue)) return;

                        // Add commas to the number
                        newValue = newValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                        var commas = newValue.split(',').length - 1;
                        maxLength += commas;

                        break;
                    case 'number':
                        maxLength = overrideMaxLength || 200;
                        newValue = newValue.replace(/[^\d]/g, '');

                        break;
                    case 'phone':
                        maxLength = overrideMaxLength || 14;

                        var phoneNumber = newValue.replace(/[^\d]/g, '');
                        var phoneNumberLength = phoneNumber.length;
                        if (phoneNumberLength >= 4 && phoneNumberLength < 7) {
                            newValue = '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3);
                        } else if (phoneNumberLength >= 7) {
                            newValue = '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6) + '-' + phoneNumber.slice(6, 10);
                        }
                        break;
                    case 'email':
                        maxLength = overrideMaxLength || 320;
                        break;
                    default:
                        break;
                }

                // Check if the value length exceeds maxLength digits
                if (newValue.length > maxLength) return;
            }

            _this.setState({ validate: validate, value: newValue });
            _this.handleBlur(newValue, precision);
        };

        _this.prepareValueForDisplay = function (value, type, precision) {
            var newValue = value;

            if (newValue && type) {
                switch (type.toLowerCase()) {
                    case 'percent':
                        // Allow for an optional negative sign, any number of digits, optional decimal point,
                        // and up to `precision` number of digits after the decimal point.
                        var regex = precision > 0 ? new RegExp('^-?\\d*(\\.\\d{0,' + precision + '})?$') : /^-?\\d*$/;
                        if (!regex.test(value)) newValue = '';
                        break;
                    case 'currency':
                        newValue = newValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                        break;
                    case 'number':
                        newValue = newValue.replace(/[^\d]/g, '');
                        break;
                    case 'phone':
                        var phoneNumber = newValue.replace(/[^\d]/g, '');
                        var phoneNumberLength = phoneNumber.length;
                        if (phoneNumberLength === 10) {
                            newValue = '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6) + '-' + phoneNumber.slice(6, 10);
                        }
                        break;
                    default:
                        break;
                }
            }

            return newValue;
        };

        _this.handleBlur = function (value) {
            _this.props.doSetReturn({ componentCode: _this.props.component.code, code: 'Value', value: _this.prepareValueForPersistence(value) });
        };

        _this.prepareValueForPersistence = function (value) {
            var type = (0, _metrixCommon.getElementValueByCode)(_this.props.component.elements, 'ValueType') || 'text';

            switch (type.toLowerCase()) {
                case 'currency':
                case 'number':
                case 'percent':
                    return value.replace(/[^0-9.-]/g, '');
                case 'phone':
                    // Remove parentheses, spaces, dashes, and any non-numeric characters
                    return value.replace(/[^\d]/g, '');
                case 'text':
                case 'email':
                    return value;
                default:
                    return value;
            }
        };

        _this.isValidPhoneNumber = function () {
            var value = _this.state.value;
            var valueType = (0, _metrixCommon.getElementValueByCode)(_this.props.component.elements, 'ValueType') || 'text';
            var regEx = /^\(\d{3}\) \d{3}-\d{4}$/;

            if (!value || valueType.toLowerCase() !== 'phone') return true;

            return regEx.test(value);
        };

        _this.isValidNumberValue = function () {
            var value = parseInt(_this.state.value.replace(/[^0-9.-]/g, ''), 10);
            var valueType = (0, _metrixCommon.getElementValueByCode)(_this.props.component.elements, 'ValueType') || 'text';
            var maxValue = parseInt((0, _metrixCommon.getElementValueByCode)(_this.props.component.elements, 'MaxValue'), 10);
            var minValue = parseInt((0, _metrixCommon.getElementValueByCode)(_this.props.component.elements, 'MinValue'), 10);

            if (isNaN(value) || isNaN(maxValue) && isNaN(minValue) || !['percent', 'currency', 'number'].includes(valueType.toLowerCase())) {
                return true;
            } else if (isNaN(maxValue)) {
                return value >= minValue;
            } else if (isNaN(minValue)) {
                return value <= maxValue;
            } else {
                return value >= minValue && value <= maxValue;
            }
        };

        _this.isValidMinOverride = function () {
            var value = _this.state.value;
            var valueType = (0, _metrixCommon.getElementValueByCode)(_this.props.component.elements, 'ValueType') || 'text';
            var overrideMinLength = parseInt((0, _metrixCommon.getElementValueByCode)(_this.props.component.elements, 'OverrideMinLength'));

            if (!value || !['text', 'number'].includes(valueType.toLowerCase())) {
                return true;
            } else {
                var isValid = true;
                if (!isNaN(overrideMinLength) && overrideMinLength > 0) {
                    var textLength = value.length;
                    isValid = textLength >= overrideMinLength;
                }
                return isValid;
            }
        };

        _this.isValidEmail = function () {
            var value = _this.state.value;
            var valueType = (0, _metrixCommon.getElementValueByCode)(_this.props.component.elements, 'ValueType') || 'text';
            var regEx = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (!value || valueType.toLowerCase() !== 'email') return true;

            return regEx.test(value);
        };

        _this.state = {
            value: '',
            validate: false
        };
        return _this;
    }

    _createClass(WorkflowInput, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            setTimeout(function () {
                if (_this2.props.return && Array.isArray(_this2.props.return.elements) && _this2.props.return.elements.length > 0) {
                    // NOSONAR
                    var valueType = (0, _metrixCommon.getElementValueByCode)(_this2.props.component.elements, 'ValueType') || 'text';
                    var propPrecision = (0, _metrixCommon.getElementValueByCode)(_this2.props.component.elements, 'Precision');
                    var value = (0, _metrixCommon.getReturnElementByCode)(_this2.props.return, 'Value');
                    var precision = void 0;

                    if (valueType.toLowerCase() === 'percent') {
                        precision = propPrecision || 2;
                    }

                    if (value !== _this2.state.value) {
                        _this2.setState({ value: _this2.prepareValueForDisplay(value, valueType, precision) });
                    }
                }
            }, 50);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var valueType = (0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'ValueType') || 'text';
            var propPrecision = (0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'Precision');
            var propSymbolLabelAlign = (0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'UnitAlignment');

            var precision = void 0;
            var symbolLabel = null;
            var symbolLabelAlign = null;

            switch (valueType.toLowerCase()) {
                case 'currency':
                    symbolLabel = '$';
                    symbolLabelAlign = _metrixCommon.Alignments.left;
                    break;
                case 'percent':
                    precision = propPrecision || 2;
                    symbolLabel = '%';
                    symbolLabelAlign = propSymbolLabelAlign ? _metrixCommon.Alignments[propSymbolLabelAlign] : _metrixCommon.Alignments.right;
                    break;
                default:
                    break;
            }

            var isRequired = (0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'Required') !== 'no';

            var componentError = !isRequired && this.state.validate === true && !(0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'valid') && valueType === 'Phone' && (0, _metrixCommon.getReturnElementByCode)(this.props.return, 'Value');

            return _react2.default.createElement(
                _metrixCommon.Container,
                { bottom: _metrixCommon.Sizes.xs },
                _react2.default.createElement(StyledInput, { label: (0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'Label')
                    // type={['percent', 'currency', 'number'].includes(valueType.toLowerCase()) ? 'number' : valueType.toLowerCase()}
                    , placeholder: (0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'Placeholder'),
                    value: this.state.value,
                    changeEvent: function changeEvent(value) {
                        return _this3.handleReturn(value, valueType, precision);
                    }
                    // onBlur={() => this.handleBlur(precision)}
                    , extraLabelValue: (0, _metrixCommon.getReturnElementByCode)(this.props.return, 'Quantifier') && { code: (0, _metrixCommon.getReturnElementByCode)(this.props.return, 'Quantifier') },
                    extraLabels: (0, _metrixCommon.getElementsByCode)(this.props.component.elements, 'Options'),
                    extraLabelChange: function extraLabelChange(value) {
                        _this3.props.doSetReturn({
                            componentCode: _this3.props.component.code,
                            code: 'Quantifier',
                            value: value.code
                        });
                        _this3.props.doSetReturn({
                            componentCode: _this3.props.component.code,
                            code: 'Label',
                            value: value.value
                        });
                    },
                    extraLabelAlign: 'right',
                    optional: !isRequired,
                    error: componentError || !this.isValidNumberValue() || !this.isValidEmail() || !this.isValidPhoneNumber() || !this.isValidMinOverride(),
                    symbolLabel: symbolLabel,
                    symbolLabelAlign: symbolLabelAlign
                })
            );
        }
    }]);

    return WorkflowInput;
}(_react2.default.Component);

WorkflowInput.propTypes = {
    component: _propTypes2.default.object.isRequired,
    doSetReturn: _propTypes2.default.func.isRequired,
    return: _propTypes2.default.object.isRequired
};

exports.default = WorkflowInput;